import { Component, inject, signal } from "@angular/core"
import { RouterLink, RouterLinkActive } from "@angular/router"
import { MatIconModule } from "@angular/material/icon"
import { I18nStore } from "../../../i18n/store/i18n.store"
import { ERoutes } from "../../constants/routes.enum"

interface NavItem {
  label: string
  route: string
  exact?: boolean
}

@Component({
  selector: "app-app-bar",
  standalone: true,
  imports: [RouterLink, RouterLinkActive, MatIconModule],
  templateUrl: "./app-bar.component.html",
  styleUrl: "./app-bar.component.scss",
})
export class AppBarComponent {
  private readonly i18nStore = inject(I18nStore)

  readonly menuOpen = signal(false)

  readonly navItems: NavItem[] = [
    { label: "Home", route: ERoutes.HOME, exact: true },
    { label: "Spots", route: ERoutes.SPOTS },
    { label: "Insight", route: ERoutes.INSIGHT },
    { label: "CTBE", route: ERoutes.HUB },
    { label: "About", route: ERoutes.ABOUT },
  ]

  get homeLink(): string[] {
    return [this.i18nStore.routeRoot]
  }

  routeLink(route: string): string[] {
    return route ? [this.i18nStore.routeRoot, route] : [this.i18nStore.routeRoot]
  }

  toggleMenu(): void {
    this.menuOpen.update((open) => !open)
  }

  closeMenu(): void {
    this.menuOpen.set(false)
  }

}
